import type { CncApp } from '@/types';

export const CNC_APPS: CncApp[] = [
  {
    id:          'nc-manager',
    name:        'NC Manager',
    description: 'Les contremaîtres ouvrent une non-conformité depuis le plancher : dictée vocale dans leur langue natale, photos intégrées, envoi automatique au département qualité pour analyse et traitement. Zéro paperasse.',
    icon:        'AlertTriangle',
    colorVar:    'var(--color-reagir)',
    colorRgbVar: 'var(--color-reagir-rgb)',
    tag:         'Voice · Photos · ERP',
  },
  {
    id:          'expeditions',
    name:        'Gestion des Expéditions',
    description: 'Numéro de commande → pièces associées depuis l\'ERP → dimensions + poids + photos → génération automatique des documents de transport et notification aux bureaux. Tout centralisé dans Teams.',
    icon:        'Package',
    colorVar:    'var(--color-anticiper)',
    colorRgbVar: 'var(--color-anticiper-rgb)',
    tag:         'ERP · Docs auto · Teams',
  },
  {
    id:          'gantt',
    name:        'Gantt Production',
    description: 'Planification de la production relié à l\'ERP Notixia (temps issus des soumissions) et à Leankit (Kanban de prod). Vue Gantt complète avec gestion des priorités et délais en temps réel.',
    icon:        'GanttChart',
    colorVar:    'var(--color-temps)',
    colorRgbVar: 'var(--color-temps-rgb)',
    tag:         'ERP · LeanKit · Gantt',
  },
  {
    id:          'dashboard',
    name:        'Dashboard Pilotage',
    description: 'Tableau de bord d\'entreprise entièrement interactif : CA, ventes, KPI qualité, maintenance, retards, production, soumissions — tout lié directement à la base de données ERP. Remplace PowerBI.',
    icon:        'LayoutDashboard',
    colorVar:    'var(--color-ameliorer)',
    colorRgbVar: 'var(--color-ameliorer-rgb)',
    tag:         'KPI · ERP DB · Interactif',
  },
  {
    id:          'cerveau',
    name:        'Cerveau d\'Entreprise',
    description: 'Base de connaissances IA connectée aux données ERP (qualité, maintenance, production). Facilite l\'intégration IA et génère des documents techniques fiables à partir des données réelles de l\'usine.',
    icon:        'Brain',
    colorVar:    'var(--color-ciel)',
    colorRgbVar: 'var(--color-ciel-rgb)',
    tag:         'RAG · IA · ERP · Docs',
  },
  {
    id:          'dossier-agentique',
    name:        'Dossier Qualité Agentique',
    description: '12 agents IA spécialisés orchestrés en pipeline : analyse des requis client, lecture des bons de commande, vérification des COC, mill tests et rapports NDT, annotation et renommage de chaque document, puis assemblage final structuré selon les exigences spécifiques du client. Le Cerveau de CNC orchestre tout — sans intervention humaine entre les étapes.',
    icon:        'Network',
    colorVar:    'var(--color-temps)',
    colorRgbVar: 'var(--color-temps-rgb)',
    tag:         '12 Agents · RAG · Orchestration IA',
    isFeatured:  true,
    stats: [
      { value: '12',     label: 'Agents spécialisés' },
      { value: '20 min', label: 'Dossier complet'    },
      { value: '200',    label: 'Pages générées'     },
      { value: 'A→Z',    label: 'Sans intervention'  },
    ],
  },
  {
    id:          'qms',
    name:        'QMS Intégré',
    description: 'Système qualité complet lié à l\'ERP : pilotage qualité, gestion des audits ISO 9001, suivi des instruments de mesure (étalonnage), gestion CSST — tout centralisé et traçable.',
    icon:        'ShieldCheck',
    colorVar:    'var(--color-maitrise)',
    colorRgbVar: 'var(--color-maitrise-rgb)',
    tag:         'ISO 9001 · CSST · Métrologie',
  },
];
